import React from 'react';
import { useTranslation } from 'react-i18next';
import { TouchableOpacity } from 'react-native';

import { useNavigation } from '@react-navigation/native';

import ChevronRight from '@/assets/icons/chevronRightNew';
import { LineSeparator } from '@/components/LineSeparator';
import { Screen } from '@/components/ScreenComponent';
import { ScreenNavBar } from '@/components/ScreenNavBar';
import { SizedBox } from '@/components/SizedBox';
import { Text } from '@/components/TextComponent';
import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { MaxWidthWrapper } from '@/feature/responsive-design/WebComponents';
import { productNames } from '@/hooks/use-active-product-name';
import { Product } from '@/hooks/use-jurisdiction';
import { AccountTabNavigationProp } from '@/navigation/types';
import { common } from '@/styles/styles';

import { useWalletTypes } from '../hooks/use-wallet-history';

const PLAY_HISTORY_PRODUCTS = [Product.Pickem, Product.Sweeps, Product.Arcade, Product.Casino];

type SummaryRowProps = {
    label: string;
    onPress: () => void;
};

const SummaryRow = ({ label, onPress }: SummaryRowProps) => (
    <>
        <TouchableOpacity activeOpacity={0.8} style={common.spaceBetweenRow} onPress={onPress}>
            <Box flex={1} paddingVertical={'s16'}>
                <Text variant={'bodyLarge'} color={ds.colorToken.text.primary}>
                    {label}
                </Text>
            </Box>
            <ChevronRight />
        </TouchableOpacity>
        <LineSeparator />
    </>
);

export const AccountSummaryScreen = () => {
    const { t } = useTranslation(['account_summary', 'common']);
    const { navigate } = useNavigation<AccountTabNavigationProp>();
    const { data: walletTypes } = useWalletTypes();

    return (
        <Screen edges={['top', 'bottom']}>
            <ScreenNavBar title={t('account_summary')} />
            <MaxWidthWrapper paddingHorizontal={'s16'}>
                <Text variant="bodyMedium" color={ds.colorToken.text.secondary} mt="s8" mb="s24">
                    {t('description')}
                </Text>

                <Text variant="headlineMedium" mb="s8">
                    {t('products')}
                </Text>
                {PLAY_HISTORY_PRODUCTS.map(product => (
                    <SummaryRow
                        key={product}
                        label={productNames[product]}
                        onPress={() => navigate('PlayHistory', { product })}
                    />
                ))}
                <SizedBox value={24} />

                <Text variant="headlineMedium" mb="s8">
                    {t('wallet')}
                </Text>
                {walletTypes.map(wallet => (
                    <SummaryRow
                        key={wallet}
                        label={t(`common:${wallet}`)}
                        onPress={() => navigate('WalletHistory', { wallet })}
                    />
                ))}
                <SizedBox value={24} />
            </MaxWidthWrapper>
        </Screen>
    );
};
